<template>
    <div class="app-page"
        :style="{ backgroundImage: `url(${backImg})`, backgroundSize: isDefaultBackground ? 'cover' : '50%' }">
        <AppHeader :title="title" :show-back="showBack" v-if="isShowHeader" />
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
import { AppHeader } from '@/components/layout'
import { theme } from '@/styles/theme'
defineProps<{
    title?: string
    showBack?: boolean
    isShowHeader?: boolean
    backImg?: string
    isDefaultBackground?: boolean
}>()

</script>

<style scoped lang="scss">
.app-page {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    min-height: 100vh;
    width: 100%;
    min-height: 100vh;
    background-color: v-bind('theme.colors.background');
    overscroll-behavior: contain;
    padding: 20px;
    overflow-y: auto;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 1;

}
</style>